import { getVersionMessage } from '../utils/getVersionMessage';
import { versionStore } from '../store/sceneStore';
import { useStoreRef } from '../interpreter/hooks';

const COPYRIGHT_TEXT = `(c) 2020 - ${new Date().getFullYear()} ACEWORKS Inc. All rights reserved`;

export const CopyRight = () => {
	const versionRef = useStoreRef(
		versionStore,
		(s) => s.data,
		getVersionMessage,
	);

	return (
		<div className='absolute bottom-0 right-0 z-[11] pb-4 pr-4 text-right text-white'>
			<img className='w-[150px]' src='asset/widget/AW_dark.png' />
			<p className='text-[8px]'>{COPYRIGHT_TEXT}</p>
			<p ref={versionRef} className='text-[8px] text-yellow-300' />
		</div>
	);
};
